define('flight-components/Social',['require','flight/lib/component','flight-components/mixins/withModal','flight-components/EmailShareForm','App','social-shares'],function(require){

  // Dependencies
  var component = require('flight/lib/component');
  var withModal = require('flight-components/mixins/withModal');
  var EmailShareForm = require('flight-components/EmailShareForm');
  var App = require('App');

  // social shares jQuery plugin
  require('social-shares');

  
  return component(SocialShare, withModal);
  
  // Constructor
  function SocialShare() {

    this.defaultAttrs({
      emailShareButtonSelector: '.social-likes__button_mail'
    });

    this.handleEmailShareClick = function(ev, data) {
      ev.preventDefault();
      
      this.activateModal({
        content: '#EmailShareForm',
        attr: {
          id: '#modal--email-share-form'
        }
      });
    };

    this.attachComponents = function(ev, data) {
      EmailShareForm.attachTo('.modal .email-share-form');
    };

    this.detachComponents = function(ev, data) {
      EmailShareForm.teardownAll();
    };

    this.after('initialize', function() {
      
      this.on('uiModalActivated', this.attachComponents);
      this.on('uiModalRemoved', this.detachComponents);

      this.on('click', {
        'emailShareButtonSelector': this.handleEmailShareClick
      });

    });

  };

});
